module.exports = __webpack_public_path__ + "img/1_1-parcheggio-1-bici.5c32f053.png";